module.exports = __webpack_public_path__ + "assets/images/project/lion-desktop.jpg?v=5c916584";